module.exports = __webpack_public_path__ + "img/zt1.98acb53.png";